// extracted by mini-css-extract-plugin
export default {"loader":"DefaultLoader_loader__PlgwO","rotation":"DefaultLoader_rotation__VuK9k"};